/**
 * Formats a date using a given locale and formatting options.
 *
 * @param dateInput - The date to format (string or Date object).
 * @param locale - The locale to use for formatting (e.g., 'en-US', 'de-DE').
 * @param options - Formatting options for the date.
 * @returns The formatted date string with non-breaking spaces.
 */
export function formatDate(dateInput: string | Date, locale: string, options: Intl.DateTimeFormatOptions): string {
  const formattedDate = new Date(dateInput)
    .toLocaleDateString(locale, options)
    .replace(/,/g, '')
    .replace(/ /g, '\u00A0'); // Replace spaces with non-breaking spaces

  return formattedDate;
}
